// start:ng42.barrel
import './components';
import './directives';
import './group.service';
// end:ng42.barrel

